import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useModal } from '../../../../../hooks/use-modal';
import { CustomCarrierSharingModal, ProviderActionItem, ProviderActionsMenu } from '../../components';
import { useProvidersGridContext } from '../../providers-grid-context';
import { ProviderPropType } from '../../types';
import { DeleteFulfillmentProviderModal } from '../delete-fulfillment-provider-modal';
import { FulfillmentProviderSettingsModal } from '../fulfillment-provider-settings-modal';
import { ProviderConnectionModal } from '../provider-connection-modal';
import messages from './messages';

export const FulfillmentProviderActionsMenu = (props) => {
  if (!props.provider.active) {
    return null;
  }
  return <ActionsMenu {...props} />;
};

const ActionsMenu = ({ provider, onError }) => {
  const { fulfillmentProviders } = useProvidersGridContext();

  const { open: openCarrierSharingModal, isOpen: isCarrierSharingModalOpen, close: closeCarrierSharingModal } = useModal();
  const { open: openSettingsModal, isOpen: isSettingsModalOpen, close: closeSettingsModal } = useModal();
  const { open: openDeleteProviderModal, isOpen: isDeleteProviderModalOpen, close: closeDeleteProviderModal } = useModal();
  const { open: openConnectionModal, isOpen: isConnectionModalOpen, close: closeConnectionModal } = useModal();

  const onSave = (closeFn) => {
    return () => {
      closeFn();
      fulfillmentProviders.updateList();
    };
  };

  return (
    <>
      <CustomCarrierSharingModal
        onClose={closeCarrierSharingModal}
        provider={provider}
        refreshGridData={fulfillmentProviders.updateDataGridProvider}
        show={isCarrierSharingModalOpen}
      />
      <FulfillmentProviderSettingsModal
        onClose={closeSettingsModal}
        onSave={onSave(closeSettingsModal)}
        provider={provider}
        show={isSettingsModalOpen}
      />
      <DeleteFulfillmentProviderModal
        onClose={closeDeleteProviderModal}
        onError={onError}
        provider={provider}
        show={isDeleteProviderModalOpen}
      />
      <ProviderConnectionModal
        onClose={closeConnectionModal}
        onError={onError}
        sellerFulfillmentProviderId={`${provider.sellerFillProviderId}`}
        show={isConnectionModalOpen}
      />
      <ProviderActionsMenu>
        <ProviderActionItem onClick={openSettingsModal}>
          <FormattedMessage {...(provider.isIntegrated ? messages.shipStationSettings : messages.editSettings)} />
        </ProviderActionItem>
        <ProviderActionItem disabled={!provider.active} onClick={openConnectionModal} show={!!provider.isIntegrated}>
          <FormattedMessage {...messages.carrierSettings} />
        </ProviderActionItem>
        <ProviderActionItem disabled={provider?.carrierSharing?.notSupported} onClick={openCarrierSharingModal}>
          <FormattedMessage {...messages.carrierSharing} />
        </ProviderActionItem>
        <ProviderActionItem onClick={openDeleteProviderModal} theme='danger-link'>
          <FormattedMessage {...messages.deactivateFulfillmentProvider} />
        </ProviderActionItem>
      </ProviderActionsMenu>
    </>
  );
};

FulfillmentProviderActionsMenu.propTypes = {
  onError: PropTypes.func.isRequired,
  provider: ProviderPropType.isRequired,
};

ActionsMenu.propTypes = FulfillmentProviderActionsMenu.propTypes;
